import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes preserving the rightmost winner.
 *
 * Use across the codebase to compose conditional classNames without conflict
 * (e.g. `cn('px-4', isLarge && 'px-6')` -> `'px-6'`, never `'px-4 px-6'`).
 *
 * Pure function (clean-code §2): no DOM access, no side effects, total over
 * any combination of `ClassValue` inputs.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
